<template>
  <b-form-group
    :description="description"
    label-for="dsdcCareer"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
  >
    <template v-slot:label>
      <span>{{ label }}</span>
    </template>

    <v-select
      id="career"
      v-model="temp"
      :options="dsdcCareers"
      :reduce="(career) => career.value"
      :clearable="false"
      label="label"
      placeholder="เลือกสาขาอาชีพ"
      @input="update"
    ></v-select>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'DsdcLevelSelector',
  components: { vSelect },
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    value: { type: String, default: null },
    attribute: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
    company: { default: null, type: Object },
  },
  data() {
    return {
      validFeedback: '',
      invalidFeedback: '',
      temp: this.value,
      dsdcCareers: [
        { value: 'การบริหารกิจการ และการให้บริการทางวิชาชีพ', label: 'การบริหารกิจการ และการให้บริการทางวิชาชีพ' },
        { value: 'การเกษตรและเทคโนโลยีชีวภาพ', label: 'การเกษตรและเทคโนโลยีชีวภาพ' },
        { value: 'การผลิตเชื้อเพลิงชีวภาพ เคมีชีวภาพ ผลิตภัณฑ์เคมี และไบโอดีเซล', label: 'การผลิตเชื้อเพลิงชีวภาพ เคมีชีวภาพ ผลิตภัณฑ์เคมี และไบโอดีเซล' },
        { value: 'การพัฒนาบุคลากร', label: 'การพัฒนาบุคลากร' },
        { value: 'การพิมพ์และสื่อสารมวลชน', label: 'การพิมพ์และสื่อสารมวลชน' },
        { value: 'การวิจัย', label: 'การวิจัย' },
        { value: 'เครื่องจักรกลและการผลิต', label: 'เครื่องจักรกลและการผลิต' },
        { value: 'ด้านการแพทย์ และสุขภาพ', label: 'ด้านการแพทย์ และสุขภาพ' },
        { value: 'ท่องเที่ยว กีฬา และการจัดนิทรรศการ', label: 'ท่องเที่ยว กีฬา และการจัดนิทรรศการ' },
        { value: 'เทคโนโลยีดิจิทัล', label: 'เทคโนโลยีดิจิทัล' },
        { value: 'ธุรกิจการเงินและการจัดการทรัพย์สิน', label: 'ธุรกิจการเงินและการจัดการทรัพย์สิน' },
        { value: 'ธุรกิจบริการและพาณิชย์', label: 'ธุรกิจบริการและพาณิชย์' },
        { value: 'ผลิตยานยนต์และชิ้นส่วน', label: 'ผลิตยานยนต์และชิ้นส่วน' },
        { value: 'ผลิตอาหารและการแปรรูปอาหาร', label: 'ผลิตอาหารและการแปรรูปอาหาร' },
        { value: 'พลังงานและสาธารณูปโภค', label: 'พลังงานและสาธารณูปโภค' },
        { value: 'เฟอร์นิเจอร์', label: 'เฟอร์นิเจอร์' },
        { value: 'แฟชั่นและอุตสาหกรรมศิลป์', label: 'แฟชั่นและอุตสาหกรรมศิลป์' },
        { value: 'ไฟฟ้าและอิเล็กทรอนิกส์', label: 'ไฟฟ้าและอิเล็กทรอนิกส์' },
        { value: 'ระบบอัตโนมัติและหุ่นยนต์', label: 'ระบบอัตโนมัติและหุ่นยนต์' },
        { value: 'โลจิสติกส์และการขนส่ง', label: 'โลจิสติกส์และการขนส่ง' },
        { value: 'โลหการ', label: 'โลหการ' },
        { value: 'เหมืองแร่', label: 'เหมืองแร่' },
      ],
    };
  },
  watch: {
    value(newVal) {
      this.temp = newVal;
    },
  },
  computed: {
    ...mapGetters('CourseManagement', [
      'isLoading',
      'courseInfo',
      'courseAttributeUpdated',
    ]),
  },
  methods: {
    ...mapActions('CourseManagement', ['updateDsdcCareerField', 'getCourseInfo']),
    update() {
      this.updateDsdcCareerField({
        courseId: this.$route.params.courseId,
        dsdcCareerField: this.temp,
      }).then(() => {
        this.getCourseInfo({
          courseId: this.$route.params.courseId,
          temp: true,
          excepts: 'numberOfStudent,numberOfActiveStudent',
        });
      });
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 5px 4px;
}
.vs__search,
.vs__search:focus {
  border: 0px solid transparent;
}
</style>
